import { Input } from '@cloudscape-design/components';
import React, { forwardRef, useEffect, useState } from 'react';
import { formatPhone, isPhoneValid } from '../pages/commons/functions';
const _preserve = React.version;

interface PhoneInputProps {
  value: string; // Removed optional '?' to ensure we have a base number
  disabled?: boolean;
  readonly?: boolean;
  fullWidth?: boolean;
  width?: number;
  placeholder?: string;
  onChange?: (val: string) => void; // Changed to number as it's cleaner for currency
}

export type SelectUserHandle = {
  focus: () => void;
};

const PhoneInput = forwardRef<SelectUserHandle, PhoneInputProps>(
  ({ value = "0", disabled = false, readonly = false, width = 200, onChange, fullWidth = false, placeholder }, ref) => {
    // 1. Sync the display state with the prop value
    const [displayValue, setDisplayValue] = useState<string>("");
    const [isEditing, setIsEditing] = useState<boolean>(false);

    // Sync internal state when the external value changes (e.g., from an API or Reset)
    useEffect(() => {
      if (!isEditing) {
        setDisplayValue(formatPhone(value));
      }
    }, [value, isEditing]);

    return (
      <div
        onClick={(e) => { e.stopPropagation(); }}
        style={{ width: fullWidth ? '100%' : width }}
      >
        <Input
          invalid={!isEditing && value && value.length > 0 && !isPhoneValid(value) ? true : false}
          autoComplete={false}
          value={displayValue}
          placeholder={placeholder && placeholder !== "" ? placeholder : 'Formato 56XXXXXXXXX'}
          inputMode="tel"
          readOnly={readonly}
          disabled={disabled}
          // This helps mobile devices show only the number pad
          onChange={({ detail }) => {
            // This line strictly allows ONLY numbers
            const cleanValue = detail.value.replace(/\D/g, "");
            setDisplayValue(cleanValue);
            onChange?.(cleanValue || "");
          }}
          onFocus={() => {
            setIsEditing(true);
            // If value is 0, clear it so user doesn't have to delete the 0
            const cleanValue = value.replace(/\D/g, "");
            setDisplayValue(cleanValue.toString());
          }}
          onBlur={() => {
            setIsEditing(false);
            formatPhone(value)
          }}
        />
      </div>
    );
  }
);

export default PhoneInput;